import { render, staticRenderFns } from "./EmailVerifyUnauthorized.vue?vue&type=template&id=ebc10660&scoped=true"
import script from "./EmailVerifyUnauthorized.vue?vue&type=script&lang=ts"
export * from "./EmailVerifyUnauthorized.vue?vue&type=script&lang=ts"
import style0 from "./EmailVerifyUnauthorized.vue?vue&type=style&index=0&id=ebc10660&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc10660",
  null
  
)

export default component.exports